import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
import { toggleAlertModal } from '../../../redux/actions/alertActions';
export const policyDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.addPolicy',
        popover: {
          title: 'Add New Policy',
          description:
            'Click here to create a new policy. Policies help define rules and guidelines that govern specific areas of your application.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.editPolicy',
        popover: {
          title: 'Edit Existing Policy',
          description:
            'This option allows you to modify an existing policy. Make sure to review and update the necessary fields before saving.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.deletePolicy',
        popover: {
          title: 'Delete Policy',
          description: 'Use this option to permanently delete a policy. Be cautious, as this action cannot be undone.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.policyMainTable',
        popover: {
          title: 'Policy Management Overview',
          description:
            'This table provides a comprehensive overview of all policies in your system. You can add, edit, or delete policies from here.',
          side: 'left',
          align: 'start',
          onNextClick: () => {
            dispatch(toggleAlertModal());
            driverObj.destroy();
          },
        },
      },
    ],
  });
  return driverObj;
};
export default policyDriverObj;
